import React, { useEffect, createContext, useState } from "react";
import {
  ContextProviderProps,
  UserLoginInfo,
  ProductContextInfo,
  ProVerContextInfo,
} from "../../types/context";
import { AuthDetails } from "../../model/user";
import { IProductInfo, LoginDetails, OktaConfigDetails } from "../../model";
import { appLogger } from "../../utils";

const defaultOkta: OktaConfigDetails = {
  clientId: "",
  issuer: "",
  apiKey: "",
  apiUrl: "",
  groupRoleMap: {},
};

const initUserContext = {
  userInfo: {
    isAuthenticated: false,
    idToken: null,
    accessToken: null,
    userDetails: null,
    isSsoUser: false,
  },
  orgId: "",
  setOrgId: () => {},
  setUserInfo: () => {},
  isAuthenticated: false,
  setIsAuthenticated: () => {},
  loginInfo: {
    cognito: {
      appClientId: "",
      appClientURL: "",
      userpoolId: "",
      userpoolRegion: "",
    },
    okta: defaultOkta,
  },
  setLoginInfo: () => {},
  isLoaded: false,
  setIsLoaded: () => {},
  ProVersion: {
    product: "",
    version: "",
  },
  setProVersion: () => {},
  contextProVersion: {},
  setcontextProVersion: () => {},
  filterDate: {
    startDate: "",
    endDate: "",
  },
  setFilterDate: () => {},
  contextRedirectProdPage: {},
  setcontextRedirectProdPage: () => {},
  setEnabledFeatures: () => {},
  BasicDetailAccordianContext: {},
  setBasicDetailAccordianContext: {},
  GenSettingsAccordianContext: {},
  setGenSettingsAccordianContext: {},
  FbSettingsAccordianContext: {},
  setFbSettingsAccordianContext: {},
  BugSettingsAccordianContext: {},
  setBugSettingsAccordianContext: {},
  FreqSettingsAccordianContext: {},
  setFreqSettingsAccordianContext: {},
  EmailSettingsAccordianContext: {},
  setEmailSettingsAccordianContext: {},
  ExttrackingSettingsAccordianContext: {},
  setExttrackingSettingsAccordianContext: {},
  setWidgAppSettingsAccordianContext: {},
  WidgAppSettingsAccordianContext: {},
  setWidgIntgSettingsAccordianContext: {},
  WidgIntgSettingsAccordianContext: {},
  ChatAndSupportSettingsAccordionContext: {},
  setChatAndSupportSettingsAccordionContext: {},
  enabledFeatures: {},
  setWalkthroughStepIndex: () => {},
  WalkthroughStepIndex: {},
  QRSettingsAccordianContext: {},
  setQRSettingsAccordianContext: {},
  ContextCorrelationReportStartDate: {},
  ContextCorrelationReportEndDate: {},
  setContextCorrelationReportStartDate: {},
  setContextCorrelationReportEndDate: {},
  setContextMetricPageStartDate: {},
  ContextMetricPageStartDate: {},
  setContextMetricPageEndDate: {},
  ContextMetricPageEndDate: {},
};

/* const initSysDetail = {
  isLoaded: false,
  setIsLoaded: () => { },
}; */

export const UserContext = createContext<UserLoginInfo | null>(initUserContext);
/* export const SystemContext = createContext<SystemContextInfo | null>(
  initSysDetail
); */

const initProVerContext = {
  ProVersion: {
    product: "",
    version: "",
  },
  setProVersion: () => {},
};

export const ProVerContext = createContext<ProVerContextInfo | null>(
  initProVerContext
);

const UserProvider = ({ children }: ContextProviderProps) => {
  const [userInfo, setUserInfo] = useState<AuthDetails>({
    isAuthenticated: false,
    idToken: "",
    accessToken: "",
    userDetails: null,
    isSsoUser: false,
  });
  const [ProVersion, setProVersion] = useState<any>({});
  const [contextProVersion, setcontextProVersion] = useState<any>({});
  const [contextRedirectProdPage, setcontextRedirectProdPage] =
    useState<any>(false);
  const [filterDate, setFilterDate] = useState<any>({});
  const [orgId, setOrgId] = useState<string>("");
  appLogger.info({
    infoObj: {
      method: "UserProvider",
      component: "userContext",
      fileName: "index.tsx",
      userInfo: userInfo,
    },
  });
  const [BasicDetailAccordianContext, setBasicDetailAccordianContext] =
    useState<any>(false);
  const [GenSettingsAccordianContext, setGenSettingsAccordianContext] =
    useState<any>(false);
  const [FbSettingsAccordianContext, setFbSettingsAccordianContext] =
    useState<any>(false);
  const [BugSettingsAccordianContext, setBugSettingsAccordianContext] =
    useState<any>(false);
  const [FreqSettingsAccordianContext, setFreqSettingsAccordianContext] =
    useState<any>(false);
  const [
    ChatAndSupportSettingsAccordionContext,
    setChatAndSupportSettingsAccordionContext,
  ] = useState<any>(false);
  const [EmailSettingsAccordianContext, setEmailSettingsAccordianContext] =
    useState<any>(false);
  const [
    ExttrackingSettingsAccordianContext,
    setExttrackingSettingsAccordianContext,
  ] = useState<any>(false);
  const [WidgAppSettingsAccordianContext, setWidgAppSettingsAccordianContext] =
    useState<any>(false);
  const [
    WidgIntgSettingsAccordianContext,
    setWidgIntgSettingsAccordianContext,
  ] = useState<any>(false);

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [loginInfo, setLoginInfo] = useState<LoginDetails>({
    cognito: {
      appClientId: "",
      appClientURL: "",
      userpoolId: "",
      userpoolRegion: "",
    },
    okta: defaultOkta,
  });

  const [enabledFeatures, setEnabledFeatures] = useState<any>({});
  const [WalkthroughStepIndex, setWalkthroughStepIndex] = useState<any>({});
  const [QRSettingsAccordianContext, setQRSettingsAccordianContext] =
    useState<any>(false);
  const [
    ContextCorrelationReportStartDate,
    setContextCorrelationReportStartDate,
  ] = useState<any>("");
  const [ContextCorrelationReportEndDate, setContextCorrelationReportEndDate] =
    useState<any>("");

  const [ContextMetricPageStartDate, setContextMetricPageStartDate] =
    useState<any>("");
  const [ContextMetricPageEndDate, setContextMetricPageEndDate] =
    useState<any>("");

  useEffect(() => {
    try {
      const result = JSON.parse(localStorage.getItem("user") || "{}");
      if (result?.isAuthenticated) {
        setIsAuthenticated(true);
        setUserInfo(result);
        setIsLoaded(true);
      } else {
        setIsAuthenticated(false);
        setIsLoaded(true);
      }
    } catch (error) {
      appLogger.error({
        errObj: {
          method: "UserProvider",
          component: "userContext",
          fileName: "index.tsx",
          err: error,
        },
      });
    }
  }, []);

  useEffect(() => {
    if (userInfo.isAuthenticated) {
      setIsAuthenticated(true);
      appLogger.info({
        infoObj: {
          method: "useEffect",
          component: "userContext",
          fileName: "index.tsx",
          userInfo: userInfo,
        },
      });
      localStorage.setItem("user", JSON.stringify(userInfo));
    }
  }, [userInfo]);

  const userContext = {
    ...initUserContext,
    userInfo,
    setUserInfo,
    orgId,
    setOrgId,
    loginInfo,
    setLoginInfo,
    isAuthenticated,
    setIsAuthenticated,
    isLoaded,
    setIsLoaded,
    setProVersion,
    ProVersion,
    filterDate,
    setFilterDate,
    setcontextProVersion,
    contextProVersion,
    contextRedirectProdPage,
    setcontextRedirectProdPage,
    BasicDetailAccordianContext,
    setBasicDetailAccordianContext,
    GenSettingsAccordianContext,
    setGenSettingsAccordianContext,
    FbSettingsAccordianContext,
    setFbSettingsAccordianContext,
    BugSettingsAccordianContext,
    setBugSettingsAccordianContext,
    FreqSettingsAccordianContext,
    setFreqSettingsAccordianContext,
    ChatAndSupportSettingsAccordionContext,
    setChatAndSupportSettingsAccordionContext,
    EmailSettingsAccordianContext,
    setEmailSettingsAccordianContext,
    ExttrackingSettingsAccordianContext,
    setExttrackingSettingsAccordianContext,
    WidgAppSettingsAccordianContext,
    setWidgAppSettingsAccordianContext,
    WidgIntgSettingsAccordianContext,
    setWidgIntgSettingsAccordianContext,
    enabledFeatures,
    setEnabledFeatures,
    WalkthroughStepIndex,
    setWalkthroughStepIndex,
    QRSettingsAccordianContext,
    setQRSettingsAccordianContext,
    setContextCorrelationReportStartDate,
    ContextCorrelationReportStartDate,
    setContextCorrelationReportEndDate,
    ContextCorrelationReportEndDate,
    setContextMetricPageStartDate,
    ContextMetricPageStartDate,
    setContextMetricPageEndDate,
    ContextMetricPageEndDate,
  };

  return (
    <>
      <UserContext.Provider value={userContext}>
        {children}
      </UserContext.Provider>
    </>
  );
};

export default UserProvider;
